
import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import styles from './ExerciseList.module.css'
import Badge from 'react-bootstrap/Badge';
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import useApiStatusDispatch from "../../hooks/useApiStatusDispatch";
import YoutubeModal from "../YoutubeModal/YoutubeModal";
import classes from "./ExerciseList.module.css";

import {
	addExercise,
	editExercise,
	deleteExercise,
	copyExercise,
	getLibraryExercisesAfterAdding,
	getExerciseList,
	getLibraryExercises,
	getExerciseListAfterAdding,
	getAdditionalExerciseData,
	getNumRemainingDemoVideos
} from "./exerciseListSlice";

const levelBadgeVariant = level => {
	switch (level) {
		case 'Beginner': return 'success'
		case 'Intermediate': return 'primary'
		case 'Advanced': return 'danger'
	}
}

const Exercise = ({ exercise, openEditModal,muscleGroupColor,handleAddSelected,selected }) => {

	const statusDispatch = useApiStatusDispatch();
	const dispatch = useDispatch();
	const user = useSelector(state => state.users.current_user);
	const accountType = useSelector((state) => state.users.current_user.account_type)
	const isClient = useSelector((state) => state.users.current_user.account_type) === "client"
	const isTrainer = useSelector((state) => state.users.current_user.account_type) === "trainer"
	const isGym = useSelector((state) => state.users.current_user.account_type) === "gym"
	const isChain = accountType === 'chain'
	const isTrainerOrGym = useSelector((state) => state.users.current_user.account_type === "trainer" || state.users.current_user.account_type === "gym")
	const isGymTrainer = useSelector((state) => state.users.current_user.account_type === "trainer" && state.users.current_user.gym_id.length > 1)

	let clientCanEdit = (user.edit_permissions.exercise === "1") && isClient;

	//Preview Image Modal Variables
	const [show, setShow] = useState(false);
	const [previewImg, setPreviewImg] = useState({});
	const [modalVideo, setModalVideo] = useState({});

	// preview video modal
	const [demoVideoShow, setDemoVideoShow] = useState(false);
	const [uploadVideoShow, setUploadVideoShow] = useState(false);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	// copy modal
	const [showCopyModal, setShowCopyModal] = useState(false);

	function allowEditDelete(owner_type) {
		if (owner_type === accountType) {
			return (clientCanEdit || !isClient) ? true : false
		} else if (owner_type === "fitsw") {
			return ((isTrainer && !isGymTrainer) || (isGym) || isChain) ? true : false
		} else {
			return false;
		}
	}

	return (
		<>
			<div className={styles.Exercise}>
				<div className={styles.ExerciseHeader}>
					<div className="d-flex" >
						<div className="d-flex align-items-center mr-2">
							<strong className="mr-1" className={allowEditDelete(exercise.owner_type) ? "text-primary" : null}
								style={allowEditDelete(exercise.owner_type) ? { cursor: "pointer" } : null}
								onClick={() =>
									allowEditDelete(exercise.owner_type) ? openEditModal(exercise) : null
								}>
								{exercise.name}
							</strong>
						</div>

					</div>

					<div className="d-flex justify-content-between flex-wrap mr-1">
						<div className="d-flex">
							{isGymTrainer &&
								<OverlayTrigger overlay={
									<Tooltip>
										Copy Exercise
									</Tooltip>
								}>
									<Button
										onClick={e => {
											e.stopPropagation()
											setShowCopyModal(true);
										}}
										className="text-dark mr-2"
										variant="link"
										size="sm"
										style={{ cursor: "pointer" }}
									>
										<i className="fas fa-copy" />
									</Button>
								</OverlayTrigger>
							}
							{exercise.demo_video && (
								<OverlayTrigger
									key={`${exercise.demo_video}`}
									placement={"top"}
									overlay={
										<Tooltip
											id={`tooltip-top`}
											className={classes.Tooltip}
										>
											<div> Click to expand</div>
											<iframe src={exercise.demo_video}
												className={classes.ExercisePreviewImg}
												frameBorder='0'
												allow='autoplay; encrypted-media'
												allowFullScreen
												title='video'
											/>
										</Tooltip>
									}
								>
									<Button
										size="sm"
										className="text-dark mr-2 fas fa-video"
										variant="link"
										onClick={(e) => {
											setModalVideo(exercise.demo_video);
											setUploadVideoShow(true);
											e.stopPropagation();
										}}
									/>
								</OverlayTrigger>
							)}

							{exercise.demoLink && (
								<OverlayTrigger

									key={`${exercise.demoLink}`}
									placement={"left"}
									overlay={
										<Tooltip
											id={`tooltip-left`}
											className={classes.Tooltip}
										>Video Demo</Tooltip>
									}
								>
									<Button
										size="sm"
										className="text-dark mr-2 fas fa-video"
										variant="link"
										onClick={(e) => {
											setModalVideo(exercise.demoLink);
											setDemoVideoShow(true);
											e.stopPropagation();
										}}
									/>
								</OverlayTrigger>
							)}
							{exercise.previewData.src && (
								<OverlayTrigger
									key={`${exercise.preview_src}`}
									placement={"top"}
									overlay={
										<Tooltip
											id={`tooltip-top`}
											className={classes.Tooltip}
										>
											<div>Click to expand</div>
											<img
												src={exercise.previewData.src}
												className={classes.ExercisePreviewImg}
												alt="Exercise Preview"
											/>
										</Tooltip>
									}
								>
									<Button
										className="text-dark mr-2 fas fa-eye"
										variant="link"
										size="sm"
										onClick={(e) => {
											setPreviewImg(exercise);
											handleShow(true);
											e.stopPropagation();
										}}
									/>
								</OverlayTrigger>
							)}
						</div>
						<div className="d-flex align-items-right flex-wrap-reverse">
							{
								exercise.levelData.exerciseLevel !== 'None' &&
								<small style={{width:'90px'}} className="text-right">
									<Badge pill variant={levelBadgeVariant(exercise.levelData.exerciseLevel)}>
										{exercise.levelData.exerciseLevel}
									</Badge>
								</small>
							}
							<small className="text-center" style={{minWidth:'90px'}}>
								<Badge pill variant={muscleGroupColor}>
									{exercise?.muscleGroupData?.muscle_group}
								</Badge>
							</small> 
							{
								(allowEditDelete(exercise.owner_type)||isChain) &&
								<Form.Check
									style={{minWidth:'20px'}}
									className="text-right"
									onChange={e => {
										handleAddSelected(exercise.id)
									}}
									checked={selected.includes(exercise.id)}		
									type="checkbox"
								/>
							}
						</div>
				
						
		
					</div>

				</div>
				{exercise.equipmentData.length > 0 &&
					<div>
						<small className="mr-1">Equipment:</small>
						<small>
							{exercise.equipmentData.map(e => e.name).join(' | ')}
						</small>
					</div>
				}
				<div>
					{exercise.notes}
				</div>

			</div>
			<Modal show={show} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>{previewImg.name}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<img
						src={previewImg.previewData?.src}
						className={classes.ExercisePreviewImg}
					/>
				</Modal.Body>
			</Modal>


			<Modal show={uploadVideoShow} onHide={() => setUploadVideoShow(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Demo Video</Modal.Title>
				</Modal.Header>
				<Modal.Body className="d-flex justify-content-center">
					<iframe src={modalVideo}
						width="500"
						height="320"
						frameborder='0'
						allow='autoplay; encrypted-media'
						allow="fullscreen"
						title='video'
					/>
				</Modal.Body>
			</Modal>

			<YoutubeModal setDemoVideoShow={setDemoVideoShow} demoVideoShow={demoVideoShow} demoVideo={modalVideo} />


			<Modal show={showCopyModal} onHide={() => setShowCopyModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Copy Exercise</Modal.Title>
				</Modal.Header>
				<Modal.Body className="d-flex justify-content-center">
					Copy exercise to {(exercise.owner_type === "gym" || exercise.owner_type === "fitsw") ? <span>&nbsp;my exercise list?</span> : <span>&nbsp;gym exercise list?</span>}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="danger" onClick={() => setShowCopyModal(false)}> Cancel </Button>
					<Button variant="primary"
						onClick={() => {
							let payload = {
								action: "copyExercise",
								id: exercise.id,
								tgt_user_id_number: exercise.owner_type === "gym" || exercise.owner_type === "fitsw" ? user.user_id_number : user.gym_id
							}
							statusDispatch(copyExercise(payload), "exercise", "add")
								.then(() => dispatch(getLibraryExercisesAfterAdding({ tgt_user_id_number: user.user_id_number }))) //this doesnt trigger table to reload

							setShowCopyModal(false)
						}}>
						Copy
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default Exercise